export { default } from './InputUploadImg';
